import { ValidationErrorResponse } from '@provider-portal/common/api/gen/RequestResponseTypes';

import { ApiError } from '@bolteu/react-api-gateway/es';

import { GlobalAppState } from 'rdx/state';

export const selectPasswordRequestState = (state: GlobalAppState) => {
  return state.password.requestState;
};

export const selectPasswordValidationErrors = (state: GlobalAppState) => {
  if (!state.password.errors) {
    return null;
  }

  const error = state.password.errors as ApiError;

  if (!error.response) {
    return null;
  }

  const validationErrors = (error.response as ValidationErrorResponse).validation_errors;

  if (!validationErrors) {
    return null;
  }

  return validationErrors.reduce((partial, current) => {
    if (!current.property) {
      return partial;
    }

    if (!partial[current.property.toString()]) {
      // eslint-disable-next-line no-param-reassign
      partial[current.property.toString()] = [];
    }

    partial[current.property.toString()].push(current.error);
    return partial;
  }, {} as { [key: string]: string[] });
};
